import React, { createContext, useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { io } from 'socket.io-client';
import { addNotification, getNotification, setNotification } from '../container/redux/notificationSlice';

const WebSocketContext = createContext();

export const useWebSocket = () => useContext(WebSocketContext);


export const WebSocketProvider = ({ children }) => {
    const dispatch = useDispatch();
    const [socket, setSocket] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [reconnectAttempts, setReconnectAttempts] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [onlineUserIds, setOnlineUserIds] = useState([]);


    const MAX_RECONNECT_ATTEMPTS = 100000000;
    const user = useSelector((state) => state.user);
    const notification = useSelector((state) => state.notification.notificationData);

    // Sync Redux notifications to local state
    useEffect(() => {
        if (notification) {
            setNotifications((prevNotifications) => [
                ...prevNotifications,
                ...Object.values(notification),
            ]);
        }
    }, [notification]);

    useEffect(() => {
        if (user?.data?._id) {
            connectSocket();

            return () => {
                if (socket) {
                    socket.disconnect();
                }
            };
        }
    }, [user?.data?._id]);

    useEffect(() => {
        if (user?.data?._id) {
            dispatch(getNotification(user?.data?._id));
        }
    }, [user?.data?._id]);

    // connect socket
    const connectSocket = () => {

        // socket url -------------
        // --------------------------------
        // const socketUrl = "http://localhost:5000";
        // const socketUrl = "https://kingster.universalairproducts.com"; 
    const socketUrl = "https://backend.kingster.edu.in";
        
        // const socketUrl = "http://192.168.29.24:5000";    


        // socket connection -------------
        // -------------------------------- 
        const newSocket = io(socketUrl, {
            transports: ["websocket", "polling"],
            upgrade: true
        });

        // set socket -------------
        // --------------------------------
        setSocket(newSocket);

        // socket connection established -------------
        // --------------------------------
        newSocket.on("connect", () => {
            console.log("Socket.IO connection established");
            setIsConnected(true);
            setReconnectAttempts(0);

            if (user?.data?._id) {
                newSocket.emit("register", user?.data?._id);
            }
        });

        // socket disconnected -------------
        // --------------------------------
        newSocket.on("disconnect", (reason) => {
            setIsConnected(false);

            if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
                setTimeout(() => {
                    console.log("Attempting to reconnect to Socket.IO...");
                    setReconnectAttempts((prev) => prev + 1);
                    connectSocket();
                }, 2000);
            } else {
                console.log("Max reconnection attempts reached");
            }
        });

        // socket connection error -------------p
        // --------------------------------
        newSocket.on("connect_error", (error) => {
            console.log("Socket.IO connection error:", error);
        });

        // notification -------------
        // --------------------------------
        newSocket.on("notification", (data) => {
            console.log("Notification received:", data);
            // setNotifications((prevNotifications) => [data,...prevNotifications]);
            dispatch(addNotification(data));
        });

        // update online users -------------
        // --------------------------------
        newSocket.on("updateOnlineUsers", (onlineUsers) => {
            setOnlineUserIds(onlineUsers)
        });
        // Handle chat messages
        // newSocket.on("message", (data) => {
        //     console.log("New message received:", data);
        //     // setMessages((prevMessages) => [...prevMessages, data]);
        // });

        return () => {
            newSocket.off("connect");
            newSocket.off("disconnect");
            newSocket.off("connect_error");
            newSocket.off("notification");
            newSocket.off("updateOnlineUsers");

            // newSocket.off("message")
            newSocket.close();
        };
    };

    return (
        <WebSocketContext.Provider value={{ socket, isConnected, notifications, onlineUserIds }}>
            {children}
        </WebSocketContext.Provider>
    );
};

